import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiHome, FiMapPin, FiAward, FiUsers } = FiIcons;

function About() {
  const features = [
    {
      icon: FiHome,
      title: "Superior Bungalow",
      description: "SLTDA certified accommodation with 4 comfortable rooms and modern amenities"
    },
    {
      icon: FiMapPin,
      title: "Strategic Location",
      description: "Located at Panamure Junction, the gateway to Kolonna and Maduwanwela Walawwa"
    },
    {
      icon: FiAward,
      title: "Licensed & Certified",
      description: "Registration: SLTDA/SQA/BUN/01295 | License: BUN/2025/0075"
    },
    {
      icon: FiUsers,
      title: "Group Friendly",
      description: "Perfect lunch stop for tour groups with capacity for 50+ guests"
    }
  ];

  return (
    <section id="about" className="section-padding">
      <div className="container">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Your Gateway to <span className="text-gradient">Sabaragamuwa</span>
          </h2>
          <p className="text-xl text-white/80 max-w-3xl mx-auto">
            Kumarana Hotel & Restaurant stands as a premier destination at the historic Panamure Junction, 
            offering superior accommodation and authentic Sri Lankan cuisine in the heart of Sabaragamuwa Province.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="glass-card p-6 text-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
            >
              <div className="w-16 h-16 mx-auto mb-4 glass-card rounded-full flex items-center justify-center">
                <SafeIcon icon={feature.icon} className="text-2xl text-blue-300" />
              </div>
              <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
              <p className="text-white/80">{feature.description}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="mt-16 glass-card p-8 md:p-12"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold mb-6">Why Choose Kumarana?</h3>
              <ul className="space-y-4 text-white/90">
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></span>
                  <span>SLTDA Superior Bungalow certification ensures quality and safety standards</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Strategic location at the junction to Maduwanwela Walawwa and historic sites</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Authentic Sabaragamuwa cuisine featuring local specialties</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Clean, modern facilities including Western-standard restrooms</span>
                </li>
                <li className="flex items-start gap-3">
                  <span className="w-2 h-2 bg-blue-400 rounded-full mt-2 flex-shrink-0"></span>
                  <span>Dedicated driver lounge and group dining facilities</span>
                </li>
              </ul>
            </div>
            <div className="glass-card p-6">
              <h4 className="text-2xl font-semibold mb-4 text-center">Our Heritage</h4>
              <p className="text-white/80 text-center">
                Located near the historic Panamure Elephant Kraal site, we are custodians of 
                Sabaragamuwa's rich cultural heritage while providing modern hospitality services 
                to travelers exploring this beautiful region.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}

export default About;